import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const serverErrorRoute: RouteConfig<'with-page'> = {
    name: 'Error - 500',
    path: '/error/500',
    page: lazy(() => import('.')),
}